module.exports = __webpack_public_path__ + "assets/img/00058.f0ee4cf1.png";